import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';

import { Subscription } from 'rxjs';

import { Task, Workflow } from '@models';
import { isAfter, isPast, isToday } from 'date-fns';
import { CacheService } from '@services/cache.service';

@Directive({ selector: '[vz-task-text-classes]' })
export class TaskTextClassesDirective {

    readonly task          = input<Task>(undefined, { alias: 'vz-task-text-classes' });

    dueToday: boolean = false;
    dueExpired: boolean = false;
    subscription?: Subscription;

    private readonly _cache = inject(CacheService);
    private readonly _el    = inject(ElementRef);
    private readonly _r2    = inject(Renderer2);

    private _1 = effect(() => {
        const t = this.task();
        if (!t) {
            return;
        }
        const el = this._el.nativeElement;
        this._r2.removeClass(el, 'vz-task-unread');
        this._r2.removeClass(el, 'vz-task-archived');
        this._r2.removeClass(el, 'vz-task-duetoday');
        this._r2.removeClass(el, 'vz-task-expired');


        if (t.workflowId && t.dueDate) {
            if (this.subscription && !this.subscription.closed) {
                this.subscription.unsubscribe();
                this.subscription = undefined;
            }
            this.subscription = this._cache.get('workflow', t.workflowId).subscribe({
                next: st => {
                    const wf = st.item as Workflow;
                    const finished = wf?.finishStateId == t.stateId;
                    this.dueExpired = false;
                    this.dueToday = false;
                    if (t && t.dueDate) {
                        if ((t.archived || finished) && t.stateStartTime) {
                            this.dueExpired = t.dueDate && isPast(t.dueDate) && !isToday(t.dueDate) && isAfter(t.stateStartTime, t.dueDate);
                        }
                        else {
                            this.dueExpired = !!t.dueDate && isPast(t.dueDate);
                            this.dueToday = !!t.dueDate && isToday(t.dueDate);
                        }
                    }
                    if (this.dueExpired && !this.dueToday) {
                        this._r2.addClass(el, 'vz-task-expired');
                    }
                    if (this.dueToday && !finished) {
                        this._r2.addClass(el, 'vz-task-duetoday');
                    }
                },
                error: () => {}
            });
        }
        else if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }

        if (!t.flags.seen) {
            this._r2.addClass(el, 'vz-task-unread');
        }
        if (t.archived) {
            this._r2.addClass(el, 'vz-task-archived');
        }
    });

}
